import Router from 'vue-router'  //引入vue-router

import HelloWorld from '@/components/HelloWorld'
import login from '@/views/loginMd'
import home from '@/views/homePage'
import transferPage from '@/views/transferPage'
import transmitPage from '@/views/transmitPage'
import commonProblem from '@/views/commonProblem'
import sendFeedback from '@/views/sendFeedback'
import aboutPage from '@/views/aboutPage'
import changePassword from '@/views/changePassword'
import modifiedData from '@/views/modifiedData'
import homePage from '@/components/homePage'





export default new Router({
    routes: [
        {                    //每一个链接都是一个对象
            path: '/',         //链接路径
            name: 'homePage',     //路由名称，
            component: homePage   //对应的组件模板
            // component: ()=>{
            //   import("../components/HelloWorld").catch(err=>err)
            // }   //对应的组件模板
      
          },
    //配置路由，这里是个数组
    {                    //每一个链接都是一个对象
      path: '/HelloWorld',         //链接路径
      name: 'HelloWorld',     //路由名称，
      component: HelloWorld   //对应的组件模板
      // component: ()=>{
      //   import("../components/HelloWorld").catch(err=>err)
      // }   //对应的组件模板

    },
   
    {                    //每一个链接都是一个对象
      path: '/login',         //链接路径
      name: 'login',     //路由名称，
      component: login//对应的组件模板
    //   meta: {
    //     flag: true,
    //   }
        },
        {                    //每一个链接都是一个对象
            path: '/home',         //链接路径
            name: 'home',     //路由名称，
            component: home//对应的组件模板
          //   meta: {
          //     flag: true,
          //   }
        },
        {                    //每一个链接都是一个对象
            path: '/transferPage',         //链接路径
            name: 'transferPage',     //路由名称，
            component: transferPage//对应的组件模板
          //   meta: {
          //     flag: true,
          //   }
        },
        {                    //每一个链接都是一个对象
            path: '/transmitPage',         //链接路径
            name: 'transmitPage',     //路由名称，
            component: transmitPage//对应的组件模板
          //   meta: {
          //     flag: true,
          //   }
          }, {                    //每一个链接都是一个对象
            path: '/commonProblem',         //链接路径
            name: 'commonProblem',     //路由名称，
            component: commonProblem//对应的组件模板
          //   meta: {
          //     flag: true,
          //   }
          },{                    //每一个链接都是一个对象
            path: '/sendFeedback',         //链接路径
            name: 'sendFeedback',     //路由名称，
            component: sendFeedback//对应的组件模板
          //   meta: {
          //     flag: true,
          //   }
          },{                    //每一个链接都是一个对象
            path: '/aboutPage',         //链接路径
            name: 'aboutPage',     //路由名称，
            component: aboutPage//对应的组件模板
          //   meta: {
          //     flag: true,
          //   }
          },{                    //每一个链接都是一个对象
            path: '/changePassword',         //链接路径
            name: 'changePassword',     //路由名称，
            component: changePassword//对应的组件模板
          //   meta: {
          //     flag: true,
          //   }
        },
        {                    //每一个链接都是一个对象
            path: '/modifiedData',         //链接路径
            name: 'modifiedData',     //路由名称，
            component: modifiedData//对应的组件模板
          //   meta: {
          //     flag: true,
          //   }
          }
          
  ],
  // mode:history,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})